import React from "react";
import { Flex, Space, Typography } from "antd";
const { Title, Text } = Typography;
import './HeadingSubHeading.scss';
import { TextProps } from "antd/lib/typography/Text";
import { TitleProps } from "antd/lib/typography/Title";

interface Props {
    title: string;
    subTitle?: string;
    textProps?: TextProps
    titleProps?: TitleProps
    actions?: React.ReactNode
}

const HeadingSubHeading: React.FC<Props> = ({ title, subTitle, textProps, titleProps, actions }) => {
    return (
        <Flex justify="space-between">
            <Space direction="vertical" size={[0, 0]} className="main-heading" >
                <Title level={4} {...titleProps}>{title}</Title>
                {subTitle && <Text type="secondary" {...textProps}>{subTitle}</Text>}
            </Space>
            {actions}
        </Flex>
    );

};

export default HeadingSubHeading;